import React from "react"
import { css } from "@emotion/core"
import humanizeDate from "../../utils/humanizeDate"
import t from "theme"

const DateLabel = ({ date, size = t.font.size[3] }) => {
    return (
        <div
            css={css`
                color: ${t.color.lighttext};
                font-size: ${size};
            `}>
            {humanizeDate(date)}
        </div>
    )
}
export default DateLabel
